<template>
  <div class="title-button">
    <cus-button
      text="訂購人資訊"
      color="blue"
      style="min-height: 45px; padding: 0"
      @click="handleOpenBuyer"
    ></cus-button>
  </div>
  <div class="wrap">
    <div class="table">
      <div class="table-head">
        <p style="text-align: left">品名</p>
        <p>單價</p>
        <p>數量</p>
        <p>總價</p>
        <p style="text-align: left; padding-left: 20px">編輯</p>
      </div>
      <div class="h-100" :style="`display: grid; grid-template-rows: repeat(${pageItem}, ${100 / pageItem}%)`">
        <div
          v-for="(item, index) in renderList"
          :key="index"
          :class="['table-item', item.item_type === 0 ? '' : 'discount-item']"
        >
          <div>
            <p :class="item.item.label.length > 11 ? 'size-small' : ''">
              {{ item.item_index }}{{ item.item_type === 0 ? '.' : ' ' }}{{ item.item.label }}
              <span v-if="item.ticket_type" class="event-tag">
                {{ mapValue[item.ticket_type]?.label }}
              </span>
            </p>
            <p>{{ item.show_price }}</p>
            <p>{{ item.quantity }}</p>
            <p>{{ item.subtotal }}</p>
            <p>{{ item.description }}&emsp;{{ item.note ? `註：${item.note}` : '' }}</p>
          </div>
        </div>
      </div>
      <cus-page :totalPage="totalPage" v-model:currentPage="currentPage"></cus-page>
    </div>
    <div v-if="orderData.information.status === 18" class="void-status">
      已作廢：{{ orderData.information.invalid_time }} － {{ orderData.information.invalid_user }}
    </div>
    <div class="order-information">
      <p class="title">訂單資訊</p>
      <div class="content-wrap">
        <div class="w-100">
          <div v-for="(item, index) in infoItem[infoPage - 1]" :key="index" class="content">
            <div class="text">
              <p>{{ item.label }}</p>
              <!-- 來源 -->
              <div v-if="item.value === 'shop_name'">
                {{ getSystem?.erp_id + ' ' + getSystem?.name }}
              </div>
              <!-- 來源 -->
              <div v-else-if="item.value === 'source'">
                {{ mapValue[orderData.information.source]?.label
                }}{{ orderData.information.outside_order_id ? '-' + orderData.information.outside_order_id : '' }}
              </div>
              <!-- 類型 -->
              <div v-else-if="item.value === 'take_away_method'">
                {{ mapValue[orderData.information.take_away_method]?.label }}
              </div>
              <!-- 訂單狀態 -->
              <div v-else-if="item.value === 'status'">
                {{ mapOrderStatus[orderData.information.status]?.label }}
              </div>
              <!-- 發票模式/號碼 -->
              <div v-else-if="item.value === 'invoice_mode'">
                {{ orderData.invoice_info.invoice_mode === 1 ? '電子發票' : '手開發票' }}
                <br />
                {{ orderData.invoice_info.invoice_no }}
              </div>
              <!-- 發票狀態 -->
              <div v-else-if="item.value === 'invoice_status'">
                {{ mapInvoiceStatus[orderData.invoice_info.invoice_status]?.label }}
              </div>
              <!-- 載具 -->
              <div v-else-if="item.value === 'carrier'">
                <div v-if="orderData.invoice_info.carrier.length > 0">
                  <p v-for="(item, index) in orderData.invoice_info.carrier" :key="index">
                    {{ mapValue[item.invoice_carrier_type]?.label + item.code }}
                  </p>
                </div>
                <div v-else>無</div>
              </div>
              <!-- 付款方式 -->
              <div v-else-if="item.category === 'payment'">
                <p v-for="(item, index) in orderData.payment" :key="index">{{ item.label }}−{{ item.amount }}</p>
              </div>
              <div v-else>{{ orderData[item.category][item.value] || '-' }}</div>
            </div>
            <div v-if="item.line" class="line"></div>
          </div>
        </div>
      </div>
      <cus-page :totalPage="2" v-model:currentPage="infoPage"></cus-page>
    </div>
  </div>

  <!-- 彈窗 -->
  <component :is="dialogTemplate"></component>
</template>
<script>
import { ref, computed, defineAsyncComponent } from 'vue';
import { mapValue, mapOrderStatus, mapInvoiceStatus } from '@/utils/define';
import { useDialog } from '@/utils/dialog';
import { useGetters } from '@/utils/mapStore';
export default {
  name: 'all-detail-info',
  props: ['orderData'],
  components: {
    Information: defineAsyncComponent(() => import('@/components/dialog/Information.vue')),
  },
  setup(props) {
    // console.log(props.orderData);
    //取得門市資料
    const getSystem = useGetters('system', ['getSystem']);
    //處理分頁品項
    const currentPage = ref(1);
    const pageItem = ref(12);
    const totalPage = computed(() => Math.ceil(props.orderData.cart.length / pageItem.value));
    const renderList = computed(() =>
      props.orderData.cart.slice((currentPage.value - 1) * pageItem.value, currentPage.value * pageItem.value)
    );
    //訂單資訊清單
    const infoPage = ref(1);
    const infoItem = [
      [
        { label: '交易序號', category: 'transaction', value: 'serial_no' },
        { label: '門市', category: 'information', value: 'shop_name' },
        { label: '訂單時間', category: 'information', value: 'create_time', line: true },
        { label: '來源', category: 'information', value: 'source' },
        { label: '類型', category: 'information', value: 'take_away_method' },
        { label: '訂單狀態', category: 'information', value: 'status', line: true },
        { label: '訂單原金額', category: 'transaction', value: 'sub_total' },
        { label: '折扣金額', category: 'transaction', value: 'discount' },
        { label: '訂單金額', category: 'transaction', value: 'total' },
        { label: '黃金點數贈點', category: 'transaction', value: 'reward_point' },
        { label: '發票模式/號碼', category: 'invoice_info', value: 'invoice_mode' },
        { label: '發票金額', category: 'invoice_info', value: 'invoice_amount' },
        { label: '發票狀態', category: 'invoice_info', value: 'invoice_status' },
      ],
      [
        { label: '統一編號', category: 'invoice_info', value: 'buyer_tax_id' },
        { label: '載具', category: 'invoice_info', value: 'carrier', line: true },
        { label: '付款方式−金額', category: 'payment' },
      ],
    ];
    //處理付款方式
    const getPayment = () => {
      let arr = [];
      props.orderData.payment.forEach((e) => {
        arr.push(e.label);
      });
      return arr.join(',');
    };
    //處理消費者身份
    const getConsumer = () => {
      let text = '';
      if (props.orderData.member_card) text = 'APP會員';
      else if (props.orderData.card_info) text = '旺卡會員';
      else text = '一般消費者';
      return text;
    };
    //訂購人資訊
    const { dialogTemplate, openHeaderDialog } = useDialog();
    const handleOpenBuyer = () => {
      const text1 = `訂購人：${props.orderData.information?.order_user_name}
            <br />
            訂購電話：${props.orderData.information.order_user_tel}
            <br />
            取餐時間：${props.orderData.information.order_take_time}
            <br />
            地址：${props.orderData.information.order_user_address}
            <br />
            備註：${props.orderData.information.note}`;
      const text2 = `消費者：${getConsumer()}
            <br />
            會員編號：${props.orderData.member_card?.card_no || ''}
            <br />
            旺卡卡號：${props.orderData.card_info?.want_card?.card_no || ''}
            <br />
            旺卡等級：${props.orderData.card_info?.want_card?.level_description || ''}
            <br />
            旺卡類別：`;
      openHeaderDialog('buyerInfo', '', { dialogContent: [text1, text2] });
    };
    return {
      mapValue,
      mapOrderStatus,
      mapInvoiceStatus,
      getSystem,
      totalPage,
      renderList,
      currentPage,
      pageItem,
      infoPage,
      infoItem,
      getPayment,
      dialogTemplate,
      handleOpenBuyer,
    };
  },
};
</script>
<style lang="scss" scoped>
$table-width: 70%; //品項區域

.title-button {
  width: 140px;
  position: absolute;
  top: -60px;
  left: 0;
}
.wrap {
  position: relative;
  height: 100%;
  width: 100%;
  display: grid;
  grid-template-columns: $table-width auto;
  grid-column-gap: 8px;
  grid-row-gap: 4px;
}
$column_name: 250px; //品名
$column_detail: 55px; //單價、數量、折扣、總價
$column_total: 95px; //總價
$title-height: 5vh; //標題高度

@mixin content-grid {
  display: grid;
  grid-template-rows: $title-height auto 60px;
  border: 2px solid $color-gray-10;
  border-radius: 4px;
}
@mixin box-bg {
  border-radius: 4px;
  border: 2px solid $color-gray-10;
  background-color: $color-gray-3;
}
.table {
  font-size: 1.8rem;
  @include content-grid;
  @mixin table-rows-grid {
    display: grid;
    grid-template-columns: minmax(0, $column_name) repeat(2, $column_detail) $column_total minmax(0, 1fr);
    align-items: center;
    text-align: right;
    width: 100%;
    height: 100%;
  }
  &-head {
    @include table-rows-grid;
    padding: 0 15px;
    border-bottom: 2px solid $color-gray-10;
    height: 100%;
    background-color: $color-gray-3;
    font-size: 1.9rem;
  }
  &-item {
    padding: 0 15px;
  }
  &-item > div {
    @include table-rows-grid;
    border-bottom: 1px solid $color-gray-10;
  }
  &-item > div > p:first-child {
    width: 100%;
    font-weight: 500;
    color: $color-blue;
    font-size: 2rem;
    text-align: left;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  &-item > div > p:nth-of-type(4) {
    font-weight: 500;
    color: $color-blue;
    font-size: 2rem;
  }
  &-item > div > p:nth-of-type(5) {
    width: 100%;
    color: $color-gray-60;
    text-align: left;
    padding-left: 20px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .discount-item {
    color: $color-red !important;
    > div > p:first-child {
      color: $color-red !important;
    }
    > div > p:nth-of-type(4) {
      color: $color-red !important;
    }
  }
  .event-tag {
    margin-left: 4px;
    background-color: $color-red;
    color: #fff;
    font-size: 1.5rem;
    padding: 2px 5px;
    border-radius: 4px;
  }
  .size-small {
    font-size: 1.75rem !important;
  }
}
.order-information {
  @include content-grid;
  @include box-bg;
  font-size: 2rem;
  .title {
    text-align: center;
    font-size: 1.9rem;
    border-bottom: 2px solid $color-gray-10;
    line-height: $title-height;
  }
  .content-wrap {
    padding: 10px 16px;
    height: calc(100% - $title-height);
    .content {
      margin: 4px 0 !important;
      .text {
        @include flex-between;
        p,
        div {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          max-width: 220px;
        }
        div {
          text-align: right;
        }
      }
      .line {
        margin: 8px 0;
        width: 100%;
        border-bottom: 2px solid $color-gray-10;
      }
    }
    .green {
      color: $color-green;
    }
    .gray {
      color: $color-gray-30 !important;
    }
  }
}
.void-status {
  position: absolute;
  top: -55px;
  right: 0;
  width: calc(100% - $table-width - 8px);
  text-align: center;
  height: 36px;
  line-height: 36px;
  background-color: $color-green;
  color: #fff;
  border-radius: 4px;
  font-size: 1.8rem;
}
</style>
